import React, { Component } from "react";
import disableBrowserBackButton from "disable-browser-back-navigation";
import { connect } from "react-redux";
import xss from "xss";

import { Link, useNavigate } from "../utils/components/router";
import { configActions, basketActions } from "../actions";
import { RAGE_RIGHT } from "../utils/enums/RAGE_RIGHT";
import PageHeader from "./PageHeader";
import CONFIG from "../config";
import { checkResize, console, checkRageRight } from "../utils/functions";

const INVALID_LOGIN = "Ein Fehler ist aufgetreten - bitte versuchen Sie es erneut. Bitte achten Sie auf die Richtigkeit Ihrer Login-Daten.";

class MALogin extends Component {
  constructor(props) {
    super(props);
    this.authAndRedirect = this.authAndRedirect.bind(this);
  }

  state = {
    redirect: false,
    checkRedirect: true,
    id: "",
    password: "",
    authToken: null,
    showErrorMsg: false,
    message: "",
    disabled: false,
  };

  componentDidMount() {
    console.log("MALogin mount");
    disableBrowserBackButton();
    this.checkRedirect();
    checkResize();
  }

  componentDidUpdate() {
    console.log("MALogin update");
    this.checkRedirect();
  }

  async authAndRedirect(e) {
    e.preventDefault();
    let logonRequestData = this.props.configStorage.getRequestData("logon", "post", { userId: this.state.id, password: this.state.password }, true);
    const result = await this.props.dispatch(configActions.fetchAuth(logonRequestData))
      .then(() => {
        this.props.dispatch(basketActions.setOrderLimit());        
      })
      .then((data) => {
        this.setState({ showErrorMsg: true, message: data.message, disabled: true });
        if (data.timeout) {
          setTimeout(() => { this.setState({ showErrorMsg: false, message: "", disabled: false }); }, data.timeout * 1000);
        }
      })          
      .catch(error => {
        console.error(error);
        this.setState({ showErrorMsg: true, message: INVALID_LOGIN });
      });
    if (typeof this.props.authenticated === "function") {
      this.props.authenticated();
    } else if (this.props.changeCondition) { // Konditionen Ändern
      this.setState({ redirect: true });
    }
    console.log(result);
    console.log("MALogin end authenticated");
  }

  checkRedirect = () => {
    console.log("MALogin checkRedirect");
    if (this.props.redirect && this.state.redirect && this.state.checkRedirect) {
      this.setState({ checkRedirect: false });
      if (
        this.props.changeCondition &&
        checkRageRight(this.props.rightStorage.currentRight, this.props.requiredRageRight)
      ) {
        console.log("MALogin checkRedirect 1");
        this.props.navigate(this.props.configStorage.getBackToShopLink());
      } else if (this.props.changeCondition) {
        console.log("MALogin checkRedirect 2");
        this.setState({ showErrorMsg: true, redirect: false, checkRedirect: true, message: INVALID_LOGIN });
      } else if (this.props.basketStorage.isOverOrderLimit()) {
        console.log("MALogin checkRedirect 3");
        this.props.navigate(this.props.configStorage.getBackToShopLink());
      } else {
        console.log("MALogin checkRedirect 4");
        this.props.navigate(CONFIG.LINK_MITARBEITER_ADD_KUNDEN);
      }
    }
  };

  goToClientNext(e, url) {
    e.preventDefault();
    window.open(url);
  }

  handlePasswordChange(e) {
    this.setState({ password: xss(e.target.value) });
  }

  handleIdChange(e) {
    this.setState({ id: xss(e.target.value) });
  }

  render() {
    return (
      <div id={CONFIG.SHOP_ID} className="if6_outer section if6_section full-height">
        <PageHeader title={this.props.title} />
        <section className="bootstrap-iso">
          <div className="login-form">
            <div className="container p-one">
              <div className="justify-content-center">
                <div className="row col-md-10 col-lg-8 mb-two">
                  <div className="col-12">
                    <div className="modal-content card mt-two">
                      <h2 className="modal-header card-header text-h2-secondary">
                        Ihre individuellen Zugangsdaten
                      </h2>
                      <div className="modal-body card-body m-one">
                        {this.state.showErrorMsg ?
                          <div className="ui error message text-danger mb-one">
                            <div className="header">{this.state.message}</div>
                          </div> : ""}
                        <form action="" method="">
                          <div className="form-group row">
                            <label
                              htmlFor="email_address"
                              className="col-md-4 col-lg-4 col-form-label text-md-right align-self-center fs-5"
                            >
                              Benutzername
                            </label>
                            <div className="col-md-6">
                              <input
                                type="text"
                                id="email_address"
                                className="form-control"
                                name="email-address"
                                required
                                onChange={e => this.handleIdChange(e)}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="password"
                              className="col-md-4 col-lg-4 col-form-label text-md-right align-self-center fs-5"
                            >
                              Passwort:
                            </label>
                            <div className="col-md-6">
                              <input
                                type="password"
                                id="password"
                                className="form-control"
                                name="password"
                                required
                                onChange={e => this.handlePasswordChange(e)}
                              />
                            </div>
                          </div>
                          <div className="form-group row col-md-12 offset-md-4 mt-one">
                            <button
                              type="submit"
                              onClick={this.authAndRedirect}
                              className="btn btn-primary col-6 col-md-4 col-lg-2"
                              disabled={this.state.disabled}
                            >
                              Anmelden
                            </button>
                          </div>
                        </form>
                      </div>
                      <div className="modal-footer">
                        <button type="button"
                          onClick={e => this.goToClientNext(e, CONFIG.LINK_RETRIEVE_USERNAME)}
                          className="btn btn-link"
                        >
                          Benutzername vergessen?
                        </button>
                        <button type="button"
                          onClick={e => this.goToClientNext(e, CONFIG.LINK_RETRIEVE_PASSWORD)}
                          className="btn btn-link"
                        >
                          Passwort vergessen?
                        </button>
                      </div>
                    </div>
                    <div className="mt-two mb-three">
                      <Link
                        className="btn btn-info col-6 col-md-4 col-lg-2"
                        to={this.props.configStorage.getBackToShopLink()}
                      >
                        Zurück zum Shop
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div >
    );
  }
}
export default connect(store => {
  return {
    configStorage: store.configStorage,
    rightStorage: store.rightStorage,
    basketStorage: store.basketStorage,
    requiredRageRight: [RAGE_RIGHT.RAGE_BERATER_EINS, RAGE_RIGHT.RAGE_BERATER_ZWEI]
  };
})((props) => {
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return <MALogin navigate={contextNavigate} {...props} />;
});
